
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { meverBrandStory } from '../../../mocks/meverProducts';

export default function MeverBrandStory() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="py-28 lg:py-36 px-8 lg:px-32 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div
            className={`transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <div className="w-full h-96 rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/cd33fab16e935a605255bd57cd42e440.jpg"
                alt="MeVER Brand Story"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div
            className={`transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`}
          >
            <h2 className="text-3xl lg:text-4xl font-medium text-gray-900 mb-3 leading-relaxed">
              {meverBrandStory.titleJa}
            </h2>
            <p className="text-lg text-gray-500 font-medium mb-10">
              {meverBrandStory.titleEn}
            </p>
            <p className="text-base text-gray-700 leading-loose mb-6">
              {meverBrandStory.bodyJa}
            </p>
            <p className="text-sm text-gray-500 leading-relaxed">
              {meverBrandStory.bodyEn}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
